import { Component, OnInit } from '@angular/core';

import { PopoverController } from '@ionic/angular';

import { PaisService } from '../../services/pais.service';

@Component({
  selector: 'app-pais',
  templateUrl: './pais.component.html',
  styleUrls: ['./pais.component.scss'],
})
export class PaisComponent implements OnInit {
  countrys: any[];

  constructor(
    private paisService: PaisService,
    private popoverController: PopoverController
  ) {}

  ngOnInit() {
    this.countrys = this.paisService.countrys;
  }

  changeCountry(country: string) {
    this.paisService.changeCountry(country);
    this.popoverController.dismiss(country);
  }
}
